// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"479":"3c92e0c2","546":"8e75c4e6"}[chunkId] + ".css";
};